import React, { SetStateAction, useState } from 'react';

import { LEAGUE, SCOPE } from '../../config/constants';
import { DateRangeSelector } from '../Shared/Filters';
import SimpleSelector from '../Shared/Filters/SimpleSelector';

type FiltersDataOpsProps = {
  loadData: (flag:boolean)=> void;
  activeChecked: boolean;
  setActiveChecked: (activeChecked:boolean)=>void;
}

export default ({ loadData, activeChecked, setActiveChecked } : FiltersDataOpsProps) => {
  const [showFilter, setShowFilter] = useState(-1);
  const close = () => setShowFilter(-1);
  return (
    <>
      <div className="head-filters-01">
        <SimpleSelector
          show={showFilter === 0}
          close={close}
          open={() => setShowFilter(0)}
          type={LEAGUE}
          forceScope={SCOPE.DATAOPS.PAGE}
          onApply={() => loadData(true)}
        />
        <DateRangeSelector
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
          loadData={() => loadData(true)}
          onlyOne
          forceScope={SCOPE.DATAOPS.PAGE}
        />
        <div className="keep-00">
          <label className="ww-ee">
            <input
              className="styled-checkbox"
              id="styled-checkbox-2"
              type="checkbox"
              value="value2"
              checked={activeChecked}
              onChange={() => setActiveChecked(!activeChecked)}
            />
            <label htmlFor="styled-checkbox-2" className="check-l" />
          </label>
          <b>Show Active Retrack</b>
        </div>
      </div>
    </>
  );
};
